import Pill from "@ingka/pill";
import crossSmall from "@ingka/ssr-icon/paths/cross-small";
import Button from "@ingka/button";
import styles from "./ActiveFilters.module.css";

export interface FilterValue {
    key: "color" | "height_cm" | "depth_cm" | "width_cm" | "door_color" | "door_solution" | "interior_color" | "knobs_color" | "interior_family" | "interior_product_type" | "loose_interior_color" | "loose_interior_family" | "loose_interior_product_type" | "loose_interior_item" | "knobs_family" | "knobs_product_type" | "lighting_color" | "lighting_family" | "lighting_product_type" | "door_family" | "interior_item" | "knobs_item" | "lighting_item" | "door_item" | "frame_types" | "legs_color" | "legs_family" | "legs_product_type" | "legs_item" | "top_panels_color" | "top_panels_family" | "top_panels_product_type" | "top_panels_item" | "top_panel_size" | "top_panel_kind" | "front_types" | "runner_types" | "drawer_fronts_color" | "drawer_fronts_family" | "drawer_fronts_product_type" | "drawer_fronts_item";
    label: string;
    value: string | number;
}

interface ActiveFiltersProps {
    filters: FilterValue[];
    onRemove: (key: FilterValue["key"]) => void;
    onClearAll: () => void;
}

export function ActiveFilters({ filters, onRemove, onClearAll }: ActiveFiltersProps) {
    if (filters.length === 0) {
        return null;
    }

    return (
        <div className={styles.container}>
            <span className={styles.label}>Filters:</span>
            <div className={styles.chips}>
                {filters.map((filter) => (
                    <Pill
                        key={filter.key}
                        label={
                            <>
                                <span className={styles.chipLabel}>{filter.label}:</span>{" "}
                                <span className={styles.chipValue}>{String(filter.value).replace(/\n/g, ', ')}</span>
                            </>
                        }
                        onClick={() => onRemove(filter.key)}
                        trailingIcon={crossSmall}
                        size="xsmall"
                        selected
                    />
                ))}
                {filters.length > 0 && (
                    <Button text="Clear all" type="tertiary" size="small" onClick={onClearAll} />
                )}
            </div>
        </div>
    );
}
